// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"medium-hero-component_uk-open__Dka6J","grecaptcha-badge":"medium-hero-component_grecaptcha-badge__ll5yn","medium-hero":"medium-hero-component_medium-hero__GGbdc","holder":"medium-hero-component_holder__pOBHp","image":"medium-hero-component_image__RFY19","content":"medium-hero-component_content__SRI6F","top":"medium-hero-component_top__cNJ6W"};
    if(module.hot) {
      // 1793877037242
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  